<template lang="pug">
  //-
    @file 图片/视频/apk上传组件
    @author 李小龙
    @date 2018/5/31
  el-upload.file-input(action='' :auto-upload='false' :class='{"is-disabled": disabled}' :on-change='fileChange' :show-file-list='false' drag :disabled='disabled')
    .avatar(v-if='type=="image" && value' :style='{backgroundImage: "url("+value+")"}')
    video.avatar(v-if='type=="video" && value' :src='value' controls)
    .avatar(v-if='type=="apk" && value' style='background-image: url(/static/static/img/apk.png)')
    i.el-icon-upload.avatar-uploader-icon(v-if='!disabled')
    .des(v-text='des' v-if='!value && !disabled && !text')
    .text(v-if='!value && text' v-text='text')
</template>
<script>
import app from '../js/app'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    disabled: {
      default: false,
    },
    text: String, //传入自定义描述信息，在禁用时也显示
    value: {},
    type: {
      default: 'image'
    },
  },
  computed: {
    des() {
      if (this.type == 'apk') {
        return '拖入或点击上传apk<=100M'
      }
      return this.type=='image' ? '拖入或点击上传图片<=1MB' : '拖入或点击上传视频<=1M'
    },
  },
  methods: {
    fileChange(f, fileList) {
      var file = f.raw
      if (this.type == 'image') {
        if (!file.type.startsWith('image/')) {
          this.$message.error('上传只能是图片格式!')
        } else if (file.size / 1024 > 1024) { //file.size的单位是：b(字节)； 1Mb=1024Kb=1024*1024b
          this.$message.error('上传图片大小不能超过 1MB!')
        } else {
          this.uploadFile(file)
          return true
        }
      } else if (this.type == 'video') {
        if (file.type!='video/3gpp' && file.type!='video/mp4') {
          this.$message.error('上传只能是3gp或mp4视频格式!')
        } else if (file.size / 1024 > 1024) {
          this.$message.error('上传视频大小不能超过 1MB!')
        } else {
          this.uploadFile(file)
          return true
        }
      } else if (this.type == 'apk') {
        if (file.type!='application/vnd.android.package-archive') {
          this.$message.error('上传只能是apk文件!')
        } else if (file.size / (1024*1024) > 100) {
          this.$message.error('上传apk大小不能超过 100MB!')
        } else {
          this.uploadFile(file)
          return true
        }
      }
      return false
    },
    uploadFile(file) {
      var formData = new FormData()
      formData.append('file', file)
      app.post('fileUpload', {file: file.name.slice(0, file.name.lastIndexOf('.'))}, this.$el, formData).then(d => {
        if (this.type == 'apk') {
          this.$message.success('上传apk成功')
        } else {
          this.$message.success(this.type == 'image' ? '上传图片成功':'上传视频成功')
        }
        this.$emit('change', d.result[0], file)
        this.$emit('first-file-time', file.lastModifiedDate)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
my-size()
  width 240px
  height 180px

.file-input
  .el-upload
    display block
    my-size()
    .avatar
      my-size()
      display block
      background-position center
      background-repeat no-repeat
      background-size contain
    .avatar-uploader-icon
      font-size 50px
      my-size()
      line-height 180px
      display block
      margin 0
    .des
      position absolute
      bottom 0
      right 5px
      color #aaa
    .text
      position absolute
      top 0
      left 5px
      color #aaa
</style>

<style lang='stylus'>
my-size()
  width 240px
  height 180px

.file-input
  .el-upload
    >.el-upload-dragger
      my-size()
</style>



// WEBPACK FOOTER //
// src/components/file-input.vue